<template>
  <div>
    <datatable :data="tableData" :columns="headers" :actions="actions" :index="false" itemsPerPage="6"></datatable>
    <v-dialog v-model="shareDialog" max-width="500">
      <share-asset-card
        @close="closeShare"
        v-bind:asset="assetItem"
        v-bind:assetType="asset_type"
      >
      </share-asset-card>
    </v-dialog>
  </div>
</template>

<script>
import { db } from "../../firebaseDB";
import ShareAssetCard from "./shareAssetCard.vue";
import datatable from "./dataTable.vue";
import _ from "lodash";

export default {
  name: "asset-table",
  data: () => ({
    itemsPerPage: 10,
    assetType: {
      prop: "prop",
      characterModel: "character_model",
      voice: "voice",
    },
    audio: {},
    assetItem: {},
    shareDialog: false,
    actions: [],
    tableData: [],
  }),
  props: ["updated", "asset_type", "columns", "headers"],
  created() {
    this.initialize();
  },
  components: {
    ShareAssetCard,
    datatable,
  },
  watch: {
    updated: function () {
      this.initialize();
    },
  },
  computed: {
    hasRig() {
      return (
        this.asset_type === this.assetType.prop ||
        this.asset_type === this.assetType.characterModel
      );
    },
    hasPolygonCount() {
      return (
        this.asset_type === this.assetType.prop ||
        this.asset_type === this.assetType.characterModel
      );
    },
    hasDimension() {
      return (
        this.asset_type === this.assetType.prop ||
        this.asset_type === this.assetType.characterModel
      );
    },
  },
  mounted() {
    this.actions = [
      {
        color: "info",
        size: "sm",
        action: (row, index) => {
          this.editItem(row, index, true);
        },
      },
      {
        color: "primary",
        size: "sm",
        action: (row, index) => {
          this.editItem(row, index, false);
        },
      },
      {
        color: "warning",
        size: "sm",
        action: (row, index) => {
          this.shareItem(row);
        },
      },
      {
        color: "danger",
        size: "sm",
        action: (row, index) => {
          this.deleteItem(row);
        },
      },
    ];
  },
  methods: {
    updateHeader() {},
    initialize() {
      this.updateHeader();
      db.ref(`assets/asset_data/${this.asset_type}/`)
        .once("value")
        .then((snapshot) => {
          let temp = [];
          Object.keys(snapshot.val()).forEach((k) => {
            if (typeof snapshot.val()[k].meta_data !== "undefined") {
              let row = Object.assign(snapshot.val()[k], {
                id: k,
                creator: snapshot.val()[k].meta_data.creator || "unknown",
                date_uploaded:
                  snapshot.val()[k].meta_data.date_uploaded || "unknown",
                date_modified:
                  snapshot.val()[k].meta_data.date_modified ||
                  snapshot.val()[k].meta_data.date_uploaded,
              });
              row = this.setupData(row);
              delete row.meta_data;
              temp.push(row);
            } else {
              console.info(`should remove ${this.asset_type}/${k}`);
            }
          });
          return temp;
        })
        .catch((error) => {
          console.log("Error - " + error.message);
        })
        .then((snapshot) => {
          this.tableData = snapshot;
        });
    },
    setupData(row) {
      let dimension = "-";
      if (row.hasOwnProperty("dimension")) {
        dimension = row["dimension"].X ? row["dimension"].X : 0;
        dimension += row["dimension"].Y ? ", " + row["dimension"].Y : ", " + 0;
        dimension += row["dimension"].Z ? ", " + row["dimension"].Z : ", " + 0;
        row["dimension_revised"] = dimension;
      }
      if (this.asset_type === "character_model") {
        if (typeof row.fbx === "undefined") {
          row["fbx"] = {
            fileName: "",
            file: "",
            fileURL: "",
          };
        }
      }
      if (typeof row.asset_bundle === "undefined") {
        row["asset_bundle"] = {
          iOS: {
            fileName: "",
            file: "",
            fileURL: "",
          },
          Android: {
            fileName: "",
            file: "",
            fileURL: "",
          },
          WebGL: {
            fileName: "",
            file: "",
            fileURL: "",
          },
        };
      }
      if (
        this.asset_type !== "voice" &&
        typeof row.asset_bundle.WebGL === "undefined"
      ) {
        row["asset_bundle"].WebGL = {
          fileName: "",
          file: "",
          fileURL: "",
        };
      }

      return row;
    },
    editItem(item, index, showSaveButton) {
      this.$emit("edit", {
        index: index,
        id: item.id,
        item: Object.assign({}, item),
        showSaveButton: showSaveButton,
      });
      this.initialize();
    },
    shareItem(item) {
      this.shareDialog = !this.shareDialog;
      this.assetItem = _.cloneDeep(item);
    },
    deleteItem(item) {
      if (confirm(`Are you sure you want to delete ${item.name} ?`)) {
        db.ref(`assets/asset_data/${this.asset_type}/${item.id}`).remove();
        this.initialize();
      }
    },
    closeShare() {
      this.share = false;
      this.initialize();
    },
    playSound(sound) {
      if (sound) {
        const audio = new Audio(sound);
        audio.play();
      }
    },
    click(row, cell, name, index) {
      if (row.hasOwnProperty("audio") && name === "media") {
        this.playSound(row.audio.audioURL);
      }
      if (row.hasOwnProperty("video") && name === "media") {
        window.open(row.video.videoURL, "video asset", "_blank");
      }
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/assets/assetTable.vue